<template>
    <div class="mask" :style="propStyle">
        <div class="share-page" id="sharepage">
            <div class="content" id="content"
            :style="{
                top: shareData.pageType == 'HonerWeekly' ? '47%' : ''
            }">
                <!-- 徽章分享模板 -->
                <div class="newBadgeView" v-if="shareData.pageType == 'animateBadge'">
                    <div class="newBadgeView-bg">
                        <img :src="newBadgeViewBgImg">
                    </div>
                    <!-- 顶部内容区 -->
                    <div class="newBadgeView-topView">
                        <!-- 徽章内容 -->
                        <div class="newBadgeView-topView-badgeView">
                            <div class="newBadgeView-topView-badgeView-badge">
                                <img crossorigin="anonymous" :src="badgeIconImg"/>
                                <span class="yuli-view-id"
                                    v-if="shareData?.isYuli?.id"
                                    :class="{
                                        'yuli-view-id-gold': shareData?.isYuli?.role_type == 6
                                    }">
                                    #{{ shareData?.isYuli?.id }}
                                </span>
                            </div>
                            <div class="newBadgeView-topView-badgeView-name">
                                {{ shareData?.label || shareData?.name }}
                            </div>
                        </div>
                        <!-- 文本内容 -->
                        <div class="newBadgeView-topView-textView" id="share-badge-textView">
                            <div class="newBadgeView-topView-textView-label" id="share-badge-label">{{ shareData?.label || shareData?.name }}</div>
                            <div class="newBadgeView-topView-textView-time" id="share-badge-time">{{ shareData?.time }}</div>
                            <div class="newBadgeView-topView-textView-pointView">
                                <span class="newBadgeView-topView-textView-pointView-number">{{ shareData?.achievementPoint }}</span>
                                <span class="newBadgeView-topView-textView-pointView-name">{{ localesPackage?.['badgewall_achievement_points']?.[localesEnv] }}</span>
                            </div>
                            <div class="newBadgeView-topView-textView-pointView">
                                <div class="newBadgeView-topView-textView-pointView-nbV">
                                    <span class="newBadgeView-topView-textView-pointView-number">{{ shareData?.badgeTotal }}</span>
                                    <!-- <span class="newBadgeView-topView-textView-pointView-numberBd">/{{ 200 }}</span> -->
                                </div>
                                <span class="newBadgeView-topView-textView-pointView-name">{{ localesPackage?.['badgewall_total_number']?.[localesEnv] }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 中间部分 -->
                    <div class="newBadgeView-centerView" id="share-badge-centerView">
                        <div class="newBadgeView-centerView-left">
                            <div class="newBadgeView-centerView-avatarView">
                                <img crossorigin="anonymous" :src="userAvatarImg">
                            </div>
                        </div>
                        <div class="newBadgeView-centerView-right">
                            <span class="newBadgeView-centerView-username">{{ shareData.username }}</span>
                            <div class="newBadgeView-centerView-content">
                                {{
                                    // eslint-disable-next-line vue/no-parsing-error
                                    localesPackage?.['badgewall_sharepage_touser1']?.[localesEnv]?.split("<%>")?.[0]
                                }}
                                {{shareData.badgeCurrentDex}}
                                {{
                                    localesEnv == 'en' ? (
                                        shareData.badgeCurrentDex == 1 ? 'st' : (
                                            shareData.badgeCurrentDex == 2 ? 'nd' : (
                                                shareData.badgeCurrentDex == 3 ? 'rd' : 'th'
                                            )
                                        )
                                    ) : ''
                                }}
                                {{
                                    localesEnv == 'en' 
                                    ? (
                                        // eslint-disable-next-line vue/no-parsing-error
                                        localesPackage?.['badgewall_sharepage_touser1']?.[localesEnv]?.split("<%>th")?.[1]
                                    )
                                    : (
                                        // eslint-disable-next-line vue/no-parsing-error
                                        localesPackage?.['badgewall_sharepage_touser1']?.[localesEnv]?.split("<%>")?.[1]
                                    )
                                }}
                            </div>
                        </div>
                    </div>
                    <ContentFooter/>
                </div>
                <!-- 徽章周报模板 -->
                <div class="honerWeeklyView" v-if="shareData.pageType == 'HonerWeekly'">
                    <div class="honerWeeklyView-bg">
                        <img :src="honerWeeklyViewBgImg">
                    </div>
                    <!-- 顶部内容区 -->
                    <div class="honerWeeklyView-topView">
                        <!-- 分数区 -->
                        <div class="honerWeeklyView-topView-achivevementView">
                            <span class="honerWeeklyView-topView-achivevementView-label">
                                {{
                                    // eslint-disable-next-line vue/no-parsing-error
                                    (!shareData?.achievementPoint || shareData?.achievementPoint <= 1000) ? 
                                    localesPackage?.['badgewall_sharepage_label0']?.[localesEnv] : (
                                        // eslint-disable-next-line vue/no-parsing-error
                                        shareData.achievementPoint <= 2000 ? 
                                        localesPackage?.['badgewall_sharepage_label1']?.[localesEnv] : (
                                            // eslint-disable-next-line vue/no-parsing-error
                                            shareData.achievementPoint <= 3000 ? 
                                            localesPackage?.['badgewall_sharepage_label2']?.[localesEnv] :
                                            localesPackage?.['badgewall_sharepage_label3']?.[localesEnv]
                                        ) 
                                    )
                                }}
                            </span>
                            <div class="honerWeeklyView-topView-achivevementView-main">
                                <div class="honerWeeklyView-topView-achivevementView-main-text">
                                    {{ shareData?.achievementPoint || "--" }}
                                </div>
                                <img :src="dashboardBgImg">
                            </div>
                            <span class="honerWeeklyView-topView-achivevementView-content">{{localesPackage?.['badgewall_achievement_points']?.[localesEnv]}}</span>
                        </div>
                        <!-- 内容区 -->
                        <div class="honerWeeklyView-topView-textView">
                            <div class="honerWeeklyView-topView-textView-pointView" :style="{
                                marginBottom: '8px'
                            }">
                                <div class="honerWeeklyView-topView-textView-pointView-nbV" v-if="shareData?.medalRank">
                                    <span class="honerWeeklyView-topView-textView-pointView-numberBd">No.</span>
                                    <span class="honerWeeklyView-topView-textView-pointView-number">{{ shareData?.medalRank?.ranking }}</span>
                                    <span class="honerWeeklyView-topView-textView-pointView-numberBd2">
                                        ({{ 
                                            yuliToFix(
                                                ((shareData.useTotalPeople - shareData?.medalRank?.ranking + 1)/shareData.useTotalPeople*100)
                                                , 2
                                            )
                                        }}%)
                                    </span>
                                </div>
                                <div class="honerWeeklyView-topView-textView-pointView-number" v-else>--</div>
                                <span class="honerWeeklyView-topView-textView-pointView-name">{{localesPackage?.['badgewall_medal_rank']?.[localesEnv]}}</span>
                            </div>
                            <div class="honerWeeklyView-topView-textView-pointView" :style="{
                                marginBottom: '16px'
                            }">
                                <div class="honerWeeklyView-topView-textView-pointView-nbV" v-if="shareData?.pointRank">
                                    <span class="honerWeeklyView-topView-textView-pointView-numberBd">No.</span>
                                    <span class="honerWeeklyView-topView-textView-pointView-number">{{ shareData?.pointRank?.ranking }}</span>
                                    <span class="honerWeeklyView-topView-textView-pointView-numberBd2">
                                        ({{ 
                                            yuliToFix(
                                                ((shareData.useTotalPeople - shareData?.pointRank?.ranking + 1)/shareData.useTotalPeople*100)
                                                , 2
                                            )
                                        }}%)
                                    </span>
                                </div>
                                <div class="honerWeeklyView-topView-textView-pointView-number" v-else>--</div>
                                <span class="honerWeeklyView-topView-textView-pointView-name">{{localesPackage?.['badgewall_point_rank']?.[localesEnv]}}</span>
                            </div>
                            <div class="honerWeeklyView-topView-textView-pointView" :style="{
                                marginBottom: '10px'
                            }">
                                <span class="honerWeeklyView-topView-textView-pointView-number">{{ shareData?.activityDays || 0 }}</span>
                                <span class="honerWeeklyView-topView-textView-pointView-name">{{localesPackage?.['badgewall_active_days']?.[localesEnv]}}</span>
                            </div>
                            <div class="honerWeeklyView-topView-textView-pointView">
                                <div class="honerWeeklyView-topView-textView-pointView-nbV">
                                    <span class="honerWeeklyView-topView-textView-pointView-number">
                                        {{ shareData?.medalNumber }}
                                    </span>
                                    <!-- <span class="honerWeeklyView-topView-textView-pointView-numberBd">/{{ 200 }}</span> -->
                                </div>
                                <span class="honerWeeklyView-topView-textView-pointView-name">{{localesPackage?.['badgewall_medal_number']?.[localesEnv]}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 中间部分 -->
                    <div class="honerWeeklyView-centerView">
                        <!-- 图表 -->
                        <div class="honerWeeklyView-centerView-chartView">
                            <RadarEchart :RadarData="shareData.RadarData" :canvasHeight="162" :canvasWidth="240" :id="'shareChart'"></RadarEchart>
                        </div>
                        <!-- 用户区 -->
                        <div class="honerWeeklyView-centerView-userView">
                            <div class="honerWeeklyView-centerView-userView-left">
                                <div class="honerWeeklyView-centerView-userView-avatarView">
                                    <img crossorigin="anonymous" :src="userAvatarImg">
                                </div>
                            </div>
                            <div class="honerWeeklyView-centerView-userView-right">
                                <span class="honerWeeklyView-centerView-userView-username">{{ shareData.username }}</span>
                                <div class="honerWeeklyView-centerView-userView-content">
                                    {{ localesPackage?.['badgewall_sharepage_touser']?.[localesEnv] }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ContentFooter/>
                </div>
            </div>
            <share-footer @handle="footerHandle"/>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onBeforeUnmount, onMounted, ref, nextTick, getCurrentInstance } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import ShareFooter from "./components/ShareFooter.vue";
import ContentFooter from './components/ContentFooter';
import html2canvas from 'html2canvas';
import appBridging from "@/utils/appBridging.js";
import RadarEchart from "../MedelWallPage/components/RadarEchart.vue";
import { px2rem, truncateString, toFixedWithMode } from "@/utils/utils.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import newBadgeViewBg from "@/assets/images/YuliApp/badgeWall/share/2base64/newBadgeView-bg.js";
import honerWeeklyViewBg from "@/assets/images/YuliApp/badgeWall/share/2base64/honerWeeklyView-bg.js";
import dashboardBg from "@/assets/images/YuliApp/badgeWall/share/2base64/dashboard_bg.js";

export default {
components: {
    ShareFooter,
    ContentFooter,
    RadarEchart
},
props: {
    propStyle: {
        type: Object,
        default: () => {
            return {}
        },
    },
    shareData: {
        type: Object,
        default: () => {
            return {}
        },
    },
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
        imgBase64Group: (state) => state.global.imgBase64Group,
    }),
},
watch: {
    languageEnv: {
        async handler(value) {
            if(value){
                this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
                this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
    imgBase64Group: {
        async handler(value) {
            if(value){
                const { error, obj } = value;
                if(this.isEmissionRequest){
                    if(error){
                        const err_msg = JSON.stringify(obj);
                        if(err_msg?.indexOf('forbidden') > -1){
                            this.showToast();
                        }else this.reRequestUseApp(true);
                    }else this.useAppLetImg2Base642(value);
                }
            }
        },
        immediate: true,
        deep: true,
    },
},
setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const newBadgeViewBgImg = ref(null);
    const honerWeeklyViewBgImg = ref(null);
    const dashboardBgImg = ref(null);
    const badgeIconImg = ref(props.shareData?.badgeIcon);
    const userAvatarImg = ref(props.shareData?.user_avatar);
    const isEmissionRequest = ref(false); // 是否未完成请求周期
    const errorTryingTimes = ref(3); // 错误尝试次数
    const imgFrameDone = ref(0); // 本次检测的图片组未完成的数量
    const emissionCheckTimer = ref(null);
    const isIos = ref(false);
    const runTime = 2000; // 后台启动时间
    // 徽章分享dom尺寸适配
    const calculateNumberOfLines = () => {
        // 文本区域dom
        const TextContainer = document.getElementById('share-badge-textView');
        const container = document.getElementById('share-badge-label');
        const timeText = document.getElementById('share-badge-time');
        // 用户区域dom
        const userDom = document.getElementById('share-badge-centerView');
        if(!container || !TextContainer || !timeText || !userDom)return;
        const containerHeight = container.clientHeight;
        let paddingTop = 0;
        if(containerHeight <= 22){
            // 单行
            paddingTop = 17;
        }else{
            // 多行
            paddingTop = 4;
            timeText.setAttribute('style', `margin-top: ${px2rem(`-2px`)}`);
            userDom.setAttribute('style', `margin-top: ${px2rem(`36px`)}`);
        }
        TextContainer.setAttribute('style', `padding-top: ${px2rem(`${paddingTop}px`)}`)
    }

    const showToast = () => {
        proxy.$toast.show({
            msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
            type: TOAST_TYPE.ERROR,
        });
        isEmissionRequest.value = false; // 关闭请求态
    }

    /** 检查所有图片加载情况*/
    const checkAllImgDoneState = () => {
        function observeImageSrcChanges(imgElement) {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "attributes" && mutation.attributeName === "src") {
                        // 如果img的src属性发生变化，重新设置加载事件处理程序
                        imgElement.onload = function() {
                            imgFrameDone.value --;
                        };
                        imgElement.onerror = function() {
                            imgFrameDone.value --;
                        };
                    }
                }
            });

            observer.observe(imgElement, { attributes: true });
        }
        const imgElements = document.getElementsByTagName("img");
        for (const img of imgElements) {
            observeImageSrcChanges(img);
        }
    }

    /** 报错处理*/
    const reRequestUseApp = (msg = 'normal', dataGroup = []) => {
        if(errorTryingTimes.value <= 0){
            showToast();
            return;
        }
        if(msg === 'normal'){
            // 超时类型 - 发送app调用请求后，7秒左右 - 之后检查是否接收成功
            clearTimeout(emissionCheckTimer.value);
            emissionCheckTimer.value = setTimeout(()=>{
                nextTick(()=>{
                    if(isEmissionRequest.value){
                        // 还处于发生状态代表失败 - 重新请求
                        // console.log('倒计时结束，重新请求尝试');
                        // useAppLetImg2Base641();
                    }
                })
            }, 7777);
        }else if(msg === 'retry'){
            appBridging.handleImg2Base64(dataGroup);
            isEmissionRequest.value = true;
            imgFrameDone.value = dataGroup.length;
            errorTryingTimes.value --;
        }else{
            // 立即调用类型
            nextTick(()=>{
                clearTimeout(emissionCheckTimer.value);
                useAppLetImg2Base641();
                errorTryingTimes.value --;          
            })
        }
    }

    // 通过app端实现图片转base64 - 用于变量图片 - 步骤1
    const useAppLetImg2Base641 = () => {
        const userAvatarImgUrl = props.shareData.user_avatar;
        const badgeIconUrl = props.shareData.badgeIcon;
        const pageType = props.shareData.pageType || null;
        const dataGroup = [];
        const oldUserAvatarImgBase64 = sessionStorage.getItem(encodeURIComponent(userAvatarImgUrl));
        if(!oldUserAvatarImgBase64)dataGroup.push(userAvatarImgUrl);
        else userAvatarImg.value = oldUserAvatarImgBase64;
        if(pageType === 'animateBadge'){
            // 新徽章页 0 - 头像, 1 - 徽章
            const badgeIconImgBase64 = sessionStorage.getItem(encodeURIComponent(badgeIconUrl));
            if(!badgeIconImgBase64)dataGroup.push(badgeIconUrl);
            else badgeIconImg.value = badgeIconImgBase64;
        }
        if(pageType === 'HonerWeekly'){
            // 周报页 0 - 头像
        }
        console.log(dataGroup);
        if(dataGroup.length > 0){
            appBridging.handleImg2Base64(dataGroup);
            isEmissionRequest.value = true;
            imgFrameDone.value = dataGroup.length;
            reRequestUseApp();
        }
    }

    // 步骤2 - app回调 后续处理
    const useAppLetImg2Base642 = (imgGroup) => {
        console.log('useAppLetImg2Base642: ', imgGroup);
        if(imgGroup?.length <= 0){
            console.log('app - base64 callback error');
            proxy.$loading.hide();
            return;
        }
        const userAvatarImgUrl = props.shareData.user_avatar;
        const badgeIconUrl = props.shareData.badgeIcon;
        /** 判断图片空错误*/
        const isErrorImg = (img) => img == '' || !img;
        const errorImgGroup = [];
        const pageType = props.shareData.pageType || null;
        // 拿头像缓存
        const oldUserAvatarImgBase64 = sessionStorage.getItem(encodeURIComponent(userAvatarImgUrl));
        userAvatarImg.value = oldUserAvatarImgBase64 || `data:image/png;base64,${imgGroup[0]}`;
        if(!oldUserAvatarImgBase64){
            sessionStorage.setItem(encodeURIComponent(userAvatarImgUrl), `data:image/png;base64,${imgGroup[0]}`);
        }
        if(pageType === 'animateBadge'){
            // 新徽章页（常规情况） 0 - 头像, 1 - 徽章
            let badgeIconUseDex = 1;
            if(imgGroup.length > 1){
                // 两张的情况
                if(isErrorImg(imgGroup[0])){
                    errorImgGroup.push(userAvatarImgUrl);
                }
            }else {
                // 一张的情况
                badgeIconUseDex = 0;
            }
            try {
                // 处理图片
                if(isErrorImg(imgGroup[badgeIconUseDex])){
                    errorImgGroup.push(badgeIconUrl);
                }else {
                    badgeIconImg.value = `data:image/png;base64,${imgGroup[badgeIconUseDex]}`;
                    sessionStorage.setItem(encodeURIComponent(badgeIconUrl), `data:image/png;base64,${imgGroup[badgeIconUseDex]}`);
                }
            } catch (error) {
                console.log('徽章处理失败');
            }
        }
        if(pageType === 'HonerWeekly'){
            // 周报页 0 - 头像
            if(isErrorImg(imgGroup[0])){
                errorImgGroup.push(props.shareData.user_avatar);
            }
        }
        isEmissionRequest.value = false;

        // 错误图片 - 发起重新请求
        if(errorImgGroup.length > 0){
            reRequestUseApp('retry', errorImgGroup);
        }
        checkAllImgDoneState();
    }

    onBeforeMount(()=>{
        try {
            // 判断设备类型
            const ua = navigator.userAgent;
            isIos.value =
            !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || ua.indexOf("Ios") > -1;
        } catch (error) {
            isIos.value = false;
        }
    })

    onMounted(()=>{
        newBadgeViewBgImg.value = newBadgeViewBg;
        honerWeeklyViewBgImg.value = honerWeeklyViewBg;
        dashboardBgImg.value = dashboardBg;
        
        nextTick(()=>{
            // ios 使用 base64跨域
            const OldTimer = sessionStorage.getItem('share-timer');
            clearTimeout(OldTimer);
            const NewTimer = setTimeout(()=>{
                if(errorTryingTimes.value > 0){
                    useAppLetImg2Base641();
                }
            }, runTime);
            sessionStorage.setItem('share-timer', NewTimer);
        })

        // 检查文字是否溢出
        try {
            calculateNumberOfLines();
            const el = document.querySelector('.honerWeeklyView-centerView-userView-username') || document.querySelector('.newBadgeView-centerView-username');
            const elW = Number(px2rem(el.clientWidth + 'px')?.split('rem')?.[0]);
            const elH = Number(px2rem(el.clientHeight + 'px')?.split('rem')?.[0]);
            const targetW = Number(px2rem(220 + 'px')?.split('rem')?.[0]);
            const targetH = Number(px2rem(22 + 'px')?.split('rem')?.[0]);
            if(elW > targetW || elH > targetH){
                el.innerText = truncateString(el.innerText, 13);
            }
        } catch (error) {
            console.log(error);
        }
    })

    onBeforeUnmount(()=>{
        badgeIconImg.value = null;
        clearTimeout(emissionCheckTimer.value);
    })
    
    /** 页面转图片*/
    const html2ImgHandle = (state) => {
        const pageType = props.shareData.pageType || null;
        if(!pageType){
            proxy.$loading.hide();
            return;
        }
        // 容器大小初始化
        const CvSize = {width: 0, height: 0};
        if(pageType === 'animateBadge'){
            CvSize.width = 308;
            CvSize.height = 414;
        }
        if(pageType === 'HonerWeekly'){
            CvSize.width = 308;
            CvSize.height = 590;
        }
        // 获取文档元素
        const htmlContent = document.getElementById('content');
        html2canvas(htmlContent, {
            useCORS: true,
            allowTaint: true,
            backgroundColor: null,
            scale: window.devicePixelRatio
            // removeContainer: false
        }).then(canvas => {
            const base64Url = canvas.toDataURL('image/png', 1);
            const img = new Image();
            img.src = base64Url;
            img.width = 308;
            img.style = 'display: none';
            document.getElementById('sharepage').appendChild(img);
            // document.getElementById('content').setAttribute('style', "display: none");
            appBridging.handleShareImage(state, base64Url);
        }).finally(()=>{
            proxy.$loading.hide();
        })
    }
    const footerHandle = (state) => {
        if(state === 'download' || state === 'share'){
            proxy.$loading.show();
            setTimeout(async ()=>{
                //等待isEmissionRequest状态为false的时候 - 再执行后续
                while (isEmissionRequest.value && imgFrameDone.value <= 0) {
                    // 可以添加一些延迟以减小轮询频率
                    await new Promise(resolve => setTimeout(resolve, 1000)); 
                    console.log('等待isEmissionRequest.value：', isEmissionRequest.value);
                    console.log('等待imgFrameDone.value：', imgFrameDone.value);
                }
                setTimeout(()=>{
                    html2ImgHandle(state);
                }, 333);
            }, runTime)
            return;
        }
        emit('handle', state);
    }

    /** 移除图片白色背景*/
    const removeImgBg = (base64Url) => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = base64Url;
            image.width = 137;
            image.height = 137;
            image.onload = function() {
                const ratio = (window.devicePixelRatio || 1) * 2;
                const canvas = document.createElement('canvas');
                canvas.width = image.width * ratio;
                canvas.height = image.height * ratio;
                const ctx = canvas.getContext('2d');
                ctx.scale(ratio, ratio);
                ctx.drawImage(image, 0, 0, image.width, image.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                const whiteThreshold = 245; // 白色阈值
                for (let i = 0; i < data.length; i += 4) {
                    // 判断颜色是否接近白色
                    if (data[i] > whiteThreshold && data[i + 1] > whiteThreshold && data[i + 2] > whiteThreshold) {
                        data[i + 3] = 0; // 设置透明度为0
                    }
                }
                ctx.putImageData(imageData, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            }
            image.onerror = function() {
                reject(false);
            }
        })
    } 

    const yuliToFix = toFixedWithMode;

    return {
        yuliToFix,
        useAppLetImg2Base642,
        footerHandle,
        showToast,
        localesPackage,
        localesEnv,
        isEmissionRequest,
        reRequestUseApp,
        newBadgeViewBgImg,
        honerWeeklyViewBgImg,
        dashboardBgImg,
        badgeIconImg,
        userAvatarImg,
    };
},
};
</script>
  
<style lang="less" scoped>
.mask{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2000;
    left: 0;
    top: 0;
}
.share-page{
    width: 100%;
    height: 100%;
    position: relative;
    .content{
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        .newBadgeView{
            width: 308px;
            height: 414px;
            position: relative;
            padding: 27px 12px 17px 21px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &-bg{
                // --img: url("");
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                // background: var(--img) no-repeat
                // top left;
                // background-size: 100% 100%;
                z-index: -1;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            &-topView{
                display: flex;
                flex-direction: row;
                width: 100%;
                &-badgeView{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    margin-right: 15px;
                    &-badge{
                        width: 137px;
                        height: 137px;
                        margin-bottom: 3px;
                        position: relative;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    &-name{
                        width: 135px;
                        color: #000000;
                        text-align: center;
                        font-family: "PingFang SC";
                        font-size: 12px;
                        font-weight: 300;
                        line-height: 12.5px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
                &-textView{
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    font-family: "PingFang SC";
                    font-weight: 500;
                    // padding-left: 15px;
                    // padding-top: 12.5px;
                    &-label{
                        color: #000000;
                        font-size: 16px;
                        // line-height: 16px;
                        margin-top: -2px;
                        margin-bottom: 5px;
                        width: 133px;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // display: -webkit-box;
                        // -webkit-line-clamp: 2;
                        // -webkit-box-orient: vertical;
                    }
                    &-time{
                        color: #000000;
                        font-size: 12px;
                        line-height: 14.4px;
                        margin-bottom: 24px;
                    }
                    &-pointView{
                        display: flex;
                        flex-direction: column;
                        &-nbV{
                            display: flex;
                            flex-direction: row;
                            align-items: flex-end;
                            justify-content: flex-start;
                        }
                        &-number{
                            color: #8c5d00;
                            font-size: 18px;
                            font-weight: 600;
                        }
                        &-numberBd{
                            color: #8c5d00;
                            font-size: 10px;
                            font-weight: 600;
                        }
                        &-numberBd2{
                            color: #8c5d00;
                            font-size: 9px;
                            font-weight: 600;
                        }
                        &-name{
                            color: #3e3838;
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 18px;
                        }
                    }
                }
            }
            &-centerView{
                width: 100%;
                display: flex;
                flex-direction: row;
                margin-top: 45px;
                box-sizing: border-box;
                margin-bottom: 37px;
                &-avatarView{
                    margin-right: 11px;
                    img{
                        width: 40px;
                        height: 40px;
                        left: 0;
                        top: 0;
                        border-radius: 2px;
                        border: 2px solid #FFF;
                    }
                }
                &-left{
                    // width: 40px;
                }
                &-right{
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                }
                &-username{
                    color: #493639;
                    font-family: "PingFang SC";
                    font-size: 16px;
                    line-height: 19.2px;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                &-content{
                    width: 218px;
                    text-align: left;
                    color: #2f2f2f;
                    font-family: "PingFang SC";
                    font-size: 13px;
                    font-weight: 300;
                    line-height: 15.34px;
                    letter-spacing: -0.39px;
                }
            }
        }
        .honerWeeklyView{
            width: 308px;
            height: 590px;
            position: relative;
            padding: 27px 12px 12px 21px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            &-bg{
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                // background: url("~@/assets/images/YuliApp/badgeWall/share/2base64/honerWeeklyView-bg.png") no-repeat
                // top left;
                // background-size: 100% 100%;
                z-index: -1;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            &-topView{
                display: flex;
                flex-direction: row;
                width: 100%;
                margin-bottom: 0px;
                &-achivevementView{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-family: "PingFang SC";
                    text-align: center;
                    width: 165px;
                    &-label{
                        color: #8C5D00;
                        font-size: 18px;
                        line-height: 14px;
                        word-break: keep-all;
                    }
                    &-content{
                        color: #3e3838;
                        font-size: 10px;
                        font-weight: 400;
                        line-height: 18px;
                    }
                    &-main{
                        width: 143px;
                        height: 143px;
                        // background: url("~@/assets/images/YuliApp/badgeWall/honerPage/dashboard_bg.png") no-repeat
                        // top left;
                        // background-size: 100% 100%;
                        
                        position: relative;
                        &-text{
                            color: #ffcf52;
                            font-size: 24.68px;
                            font-weight: 600;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            z-index: 1;
                        }
                        img{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            left: 0;
                            top: 0;
                            z-index: 0;
                        }
                    }
                }
                &-textView{
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    font-family: "PingFang SC";
                    font-weight: 500;
                    padding-left: 22px;
                    padding-top: 6px;
                    &-pointView{
                        display: flex;
                        flex-direction: column;
                        &-nbV{
                            display: flex;
                            flex-direction: row;
                            align-items: flex-end;
                            justify-content: flex-start;
                        }
                        &-number{
                            color: #8c5d00;
                            font-size: 16px;
                            font-weight: 600;
                        }
                        &-numberBd{
                            color: #8c5d00;
                            font-size: 10px;
                            font-weight: 600;
                        }
                        &-numberBd2{
                            color: #8c5d00;
                            font-size: 8px;
                            font-weight: 600;
                        }
                        &-name{
                            color: #3e3838;
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 18px;
                            margin-top: -2px;
                        }
                    }
                }
            }
            &-centerView{
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-bottom: 36px;
                &-chartView{
                    width: 100%;
                    max-width: 250px;
                    height: 162px;
                    margin-bottom: 10px;
                    z-index: 2;
                    :deep(#view-shareChart){
                        .listView{
                            margin-top: unset;
                            .item{
                                margin-bottom: 4px;
                                .labelView{
                                    margin-bottom: 1px;
                                    .label{
                                        color: rgba(31, 34, 37, 1);
                                        font-size: 11px;
                                    }
                                    .number{
                                        color: rgba(99, 77, 0, 1);
                                        font-size: 13px;
                                    }
                                }
                                #p-echart{
                                    position: unset;
                                    height: 8px;
                                    :deep(.progress-bg){
                                        height: 4px;
                                        background: rgba(241, 237, 230, 0.5);
                                        border: 1px solid rgba(31, 34, 37, 1);
                                        .progress-bg-line{
                                            background: rgba(248, 211, 96, 1);
                                            height: 2px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                &-userView{
                    width: 275px;
                    height: 67px;
                    background: url("~@/assets/images/YuliApp/badgeWall/share/user_frame.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    padding: 8px;
                    display: flex;
                    flex-direction: row;
                    // align-items: center;
                    justify-content: center;
                    box-sizing: border-box;
                    &-avatarView{
                        margin-right: 11px;
                        img{
                            width: 30px;
                            height: 30px;
                            left: 0;
                            top: 0;
                            border-radius: 2px;
                            border: 2px solid #FFF;
                        }
                    }
                    &-left{
                        display: flex;

                    }
                    &-right{
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        // justify-content: center;
                    }
                    &-username{
                        color: #493639;
                        font-family: "PingFang SC";
                        font-size: 16px;
                        font-weight: 600;
                        line-height: 19.2px;
                        margin-bottom: 4px;
                    }
                    &-content{
                        width: 218px;
                        text-align: left;
                        color: #2f2f2f;
                        font-family: "PingFang SC";
                        font-size: 13px;
                        font-weight: 300;
                        line-height: 15.34px;
                        letter-spacing: -0.39px;
                    }
                }
            }
        }
    }
    .yuli-view{
        position: relative;
        &-id{
            position: absolute;
            bottom: 28px;
            right: 50%;
            transform: translate(50%, 0);
            color: #F2F2F2;
            font-size: 12px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
            &-gold{
                color: #fffde7;
            }
        }
        img{
            width: 160px;
            height: 160px;
        }
    }
}
</style>
  